import create from 'zustand';
import { getFileDevicesFromDB } from '../../api/devices/FilesDevicesFromDB';
import { File } from '../../types/File';

// interface File {
//     ID: string;
//     UID: string;
//     fileType: string;
//     rating?: number;
//     start: string;
// }

interface FileData {
    deviceUID?: string;
    start?: string | undefined;
    end?: string | undefined;
    rating?: number[];
    fileType?: string | undefined;
}

interface FilesStore {
    files: File[];
    filesArchive: File[];
    hasMore: boolean;
    fetchFiles: (
        fileData: FileData,
        SmartDVRToken: string,
        userLogin: string,
        page: number,
        pageSize: number,
        archive?: boolean,
    ) => Promise<void>;
    resetFiles: () => void;
    resetArchiveFiles: () => void;
    setPagination: (pagination: Partial<FilesStore['pagination']>) => void;
    updateSingleFileInStore: (updatedFile: File) => void;
    pagination: {
        current: number;
        pageSize: number;
        total: number;
    };
}

export const useFilesStore = create<FilesStore>((set) => ({
    files: [],
    filesArchive: [],
    hasMore: true, // Инициализируем hasMore
    pagination: {
        current: 1,
        pageSize: 50,
        total: 0,
    },
    fetchFiles: async (fileData, SmartDVRToken, userLogin, page, pageSize, archive) => {
        if (!userLogin || !SmartDVRToken) {
            console.error('User or token information is missing.');
            return;
        }

        try {
            const response = await getFileDevicesFromDB(
                fileData,
                SmartDVRToken,
                userLogin,
                page,
                pageSize,
            );
            const newFiles = response.data || [];
            set((state) => ({
                // filesArchive: archive
                //     ? page === 1
                //         ? newFiles
                //         : [...state.files, ...newFiles]
                //     : [],
                // files: !archive ? (page === 1 ? newFiles : [...state.files, ...newFiles]) : [],
                filesArchive: archive ? newFiles : state.filesArchive,
                files: !archive ? newFiles : state.files,
                hasMore: newFiles.length === pageSize, // Если количество загруженных файлов меньше pageSize, значит больше файлов нет
                pagination: {
                    current: page,
                    pageSize,
                    total: response.len || 0,
                },
            }));

            if (archive) {
                return response;
            }
        } catch (error) {
            console.error('Error fetching files from database:', error);
            set({ hasMore: false }); // Остановить загрузку в случае ошибки
        }
    },
    resetFiles: () => set({ files: [], hasMore: true }),
    resetArchiveFiles: () => set({ filesArchive: [], hasMore: true }),
    setPagination: (updates) =>
        set((state) => ({
            pagination: { ...state.pagination, ...updates },
        })),
    updateSingleFileInStore: (updatedFile) =>
        set((state) => ({
            files: state.files.map((file) => (file.UID === updatedFile.UID ? updatedFile : file)),
            filesArchive: state.filesArchive.map((file) =>
                file.UID === updatedFile.UID ? updatedFile : file,
            ),
        })),
}));
